// extracted by mini-css-extract-plugin
export var link = "_s0-0";